module.exports = __webpack_public_path__ + "static/media/medhanshablogo.b42c26e9.png";